import { createContext } from 'react';

import { LIGHT_THEME } from 'constants/Theme';

const ThemeContext = createContext({ theme: LIGHT_THEME, setTheme: () => {} });

export default ThemeContext;
